import PropTypes from "prop-types";
import styles from "./ResultsBlock.module.css";
import YesResultsIcon from "./Yes_Results_Icon.svg";
import NoResultsIcon from "./No_Results_Icon.svg";

/**
 * View Component. Displays the number of thumbs up and thumbs down votes with a percentage underneath
 */
export function ResultsBlock({
  thumbsUp,
  thumbsDown,
  block,
  thumbsUpPercentage,
  thumbsDownPercentage,
}) {
  const toNumber = (val) => {
    if (val == null) return NaN;
    if (typeof val === "number") return val;
    // strip any trailing % and whitespace
    const cleaned = String(val).replace(/%/g, "").trim();
    const num = Number(cleaned);
    return Number.isFinite(num) ? num : NaN;
  };

  const formatPercent = (num) =>
    `${Math.max(0, Math.min(100, Math.round(num)))}%`;

  const safePercent = (input, numerator, denominator) => {
    const parsed = toNumber(input);
    if (Number.isFinite(parsed)) {
      // Already a valid percent number
      return formatPercent(parsed);
    }
    // Fallback: compute from counts
    const total = denominator != null ? denominator : 0;
    if (!total || !Number.isFinite(total) || total <= 0) {
      return "0%";
    }
    const computed = (numerator / total) * 100;
    return formatPercent(computed);
  };

  const totalVotes = (thumbsUp || 0) + (thumbsDown || 0);
  const yesPercent = safePercent(thumbsUpPercentage, thumbsUp || 0, totalVotes);
  const noPercent = safePercent(
    thumbsDownPercentage,
    thumbsDown || 0,
    totalVotes
  );
  return (
    <div className={styles.resultsContainer}>
      <div>Block {block}</div>
      <div className={styles.votesContainer}>
        <div className={styles.column}>
          <img src={YesResultsIcon} alt="Yes Votes" className={styles.icon} />
          <span className={styles.thumbsUp}>{thumbsUp}</span>
          <span>({yesPercent})</span>
        </div>
        <div className={styles.column}>
          <img src={NoResultsIcon} alt="No Votes" className={styles.icon} />
          <span className={styles.thumbsDown}>{thumbsDown}</span>
          <span>({noPercent})</span>
        </div>
      </div>
    </div>
  );
}

ResultsBlock.propTypes = {
  thumbsUp: PropTypes.number,
  thumbsDown: PropTypes.number,
  block: PropTypes.string,
  thumbsUpPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  thumbsDownPercentage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};
